var exports = {
  "g": "negative__I8OSYV",
  "K": "copilotRun__0ZUeh9",
};

module.exports = exports;
